var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_437_16575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7528 23.3377H12.3951C12.0217 23.3377 11.7456 23.1706 11.5667 22.8363C11.3878 22.502 11.4115 22.1771 11.6378 21.8616L20.9885 8.34246C21.1437 8.1304 21.3393 7.98515 21.5752 7.90671C21.8112 7.82826 22.0508 7.83821 22.2941 7.93654C22.5374 8.02922 22.724 8.18726 22.8539 8.41064C22.9839 8.63401 23.0309 8.86939 22.9951 9.11679L21.8822 18.0164H27.1831C27.5932 18.0164 27.88 18.1958 28.0433 18.5545C28.2066 18.9133 28.1595 19.2504 27.902 19.5659L17.5893 31.9329C17.4231 32.1271 17.2199 32.2536 16.9798 32.3126C16.7398 32.3716 16.5114 32.3478 16.2948 32.2412C16.0726 32.1403 15.9004 31.985 15.7785 31.7754C15.6565 31.5657 15.6106 31.3337 15.6408 31.0793L16.7528 23.3377Z",
    stroke: "white",
    strokeWidth: 6.16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7528 23.3377H12.3951C12.0217 23.3377 11.7456 23.1706 11.5667 22.8363C11.3878 22.502 11.4115 22.1771 11.6378 21.8616L20.9885 8.34246C21.1437 8.1304 21.3393 7.98515 21.5752 7.90671C21.8112 7.82826 22.0508 7.83821 22.2941 7.93654C22.5374 8.02922 22.724 8.18726 22.8539 8.41064C22.9839 8.63401 23.0309 8.86939 22.9951 9.11679L21.8822 18.0164H27.1831C27.5932 18.0164 27.88 18.1958 28.0433 18.5545C28.2066 18.9133 28.1595 19.2504 27.902 19.5659L17.5893 31.9329C17.4231 32.1271 17.2199 32.2536 16.9798 32.3126C16.7398 32.3716 16.5114 32.3478 16.2948 32.2412C16.0726 32.1403 15.9004 31.985 15.7785 31.7754C15.6565 31.5657 15.6106 31.3337 15.6408 31.0793L16.7528 23.3377Z",
    fill: "#1C53EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_437_16575",
    x: 4.48809,
    y: 0.894336,
    width: 30.6107,
    height: 38.4096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_16575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_437_16575",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.769d81a7fca57200a122f70fefcaf36d.svg";
export { ForwardRef as ReactComponent };